module.exports = __webpack_public_path__ + "static/media/work-progress.4867a8be.png";